import { Controller } from '@hotwired/stimulus'

// Global::Partner::AccountingWorkflow refuses a save that changes an abbreviation while
// the change is marked significant, because a firm can hold back a significant change
// but reads the abbreviation off the partner record as soon as it is saved. The box
// arrives ticked, so the abbreviations stay editable and it is the save that stops:
// changing one shows the warning and disables Save until the partner reverts the
// abbreviation or unticks the box.
export default class extends Controller {
  static targets = [
    'significantChange',
    'abbreviation',
    'conflictInfo',
    'submit',
  ]

  declare readonly significantChangeTarget: HTMLInputElement
  declare readonly hasSignificantChangeTarget: boolean
  declare readonly abbreviationTargets: HTMLInputElement[]
  declare readonly conflictInfoTargets: HTMLElement[]
  declare readonly submitTargets: HTMLInputElement[]

  private initialValues = new Map<HTMLInputElement, string>()

  connect(): void {
    this.abbreviationTargets.forEach((input) => {
      this.initialValues.set(input, input.value)
    })

    this.refresh()
  }

  refresh(): void {
    if (!this.hasSignificantChangeTarget) return
    if (this.abbreviationTargets.length === 0) return

    const conflict = this.significantChangeTarget.checked && this.hasChange()

    this.conflictInfoTargets.forEach((element) => {
      element.hidden = !conflict
    })
    this.submitTargets.forEach((submit) => {
      submit.disabled = conflict
    })
  }

  // Trimmed so that the blank the form submits for an untouched abbreviation reads the
  // same as the nil it came from, matching what the server treats as a change.
  private hasChange(): boolean {
    return this.abbreviationTargets.some(
      (input) =>
        input.value.trim() !== (this.initialValues.get(input) ?? '').trim()
    )
  }
}
